import React from 'react';
import BaseShapeEditor, { EditorProps } from './baseShapeEditor';

const PathEditor: React.FC<EditorProps> = function () {
    return (
        <>
           
        </>
    );
}

export default BaseShapeEditor(PathEditor);